/* eslint-disable react/prop-types */
// @mui
import { Container, Divider, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// layouts
import Layout from '../../layouts';
// components
import Page from '../../components/Page';

import useLocales from '../../hooks/useLocales';
import useSettings from '../../hooks/useSettings';
import PlanTags from '../../sections/explorer/PlanTags';
import SchoolTags from '../../sections/explorer/SchoolTags';
import TopicTags from '../../sections/explorer/TopicTags';

// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(10),
  paddingTop: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
  },
}));

// ----------------------------------------------------------------------

HomePage.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function HomePage() {
  const { translate } = useLocales();
  const { themeStretch } = useSettings();

  return (
    <Page title={translate("explorer.title")} description={translate('explorer.description')} >
      <RootStyle >
        <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
          <Grid container spacing={2} >
            <Grid item xs={12} md={12}>
              <Typography variant="h5">{translate("explorer.title")}</Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} md={12}>
              <SchoolTags />
              <Divider sx={{ my: 1 }} />
              <PlanTags />
              <Divider sx={{ my: 1 }} />
              <TopicTags />
            </Grid>
          </Grid>
        </Container>
      </RootStyle>
    </Page >
  );
}